// Generated by scripts/generate.py. Do not edit.
export const AUTHZ_SCOPES = [
    "platform",
    "account",
    "channel",
];
